import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Skeleton } from './Skeleton'
import { Icon } from '../../atoms'

const AVATAR_SIZE = 50
const ITEM_HEIGHT = 70

export const ContactItemSkeleton: React.FC = () => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <View style={styles.container}>
      <View style={styles.leftSection}>
        <Skeleton width={AVATAR_SIZE} height={AVATAR_SIZE} borderRadius={AVATAR_SIZE / 2} />
      </View>
      <View style={styles.middleSection}>
        <Skeleton width="60%" height={16} borderRadius={4} style={styles.nameSkeleton} />
        <Skeleton width="40%" height={14} borderRadius={4} style={styles.professionSkeleton} />
        <Skeleton width="50%" height={12} borderRadius={4} style={styles.hashtagSkeleton} />
      </View>
      <View style={styles.rightSection}>
        <Icon name="arrow" size={24} color={theme.colors.grey20} />
      </View>
    </View>
  )
}

export const ContactItemSkeletonList: React.FC<{ count?: number }> = ({ count = 5 }) => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <View style={styles.listContainer}>
      {Array.from({ length: count }).map((_, index) => (
        <View key={index}>
          <ContactItemSkeleton />
          {index < count - 1 && <View style={styles.separator} />}
        </View>
      ))}
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: theme.spacing.md,
      paddingLeft: theme.spacing.md,
      height: ITEM_HEIGHT,
      paddingHorizontal: theme.spacing.lg,
    },
    leftSection: {
      marginRight: theme.spacing.md,
    },
    middleSection: {
      flex: 1,
      justifyContent: 'center',
    },
    nameSkeleton: {
      marginBottom: theme.spacing.xs,
    },
    professionSkeleton: {
      marginBottom: theme.spacing.xs / 2,
    },
    hashtagSkeleton: {
      marginTop: theme.spacing.xs / 2,
    },
    rightSection: {
      marginLeft: theme.spacing.md,
      padding: theme.spacing.sm,
    },
    listContainer: {
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.xxl,
    },
    separator: {
      height: 1,
      backgroundColor: theme.colors.grey,
      marginLeft: theme.spacing.lg,
    },
  })

